import { selectAppConfig } from "./selectAppConfig";
import {QuestionaryType} from "helpers/constants";

export const selectAnketaType = state => {
  const config = selectAppConfig(state);
  return config.blocks ? config.blocks.anketa_type : QuestionaryType.FULL;
};
